import { COLORS, COMMON_STYLES } from "@dehaat/dds";
import React, { PropsWithChildren, useContext } from "react";
import {
  Modal,
  StyleSheet,
  View,
  TouchableOpacity,
  ViewStyle,
  StyleProp,
  Dimensions,
  Pressable,
} from "react-native";
import CrossIcon from "../icons/CrossIcon";
import { ResponsiveContext } from "app/context/ResponsiveUIContext";
interface Props {
  allowClose?: boolean;
  visible: boolean;
  onClose?: () => void;
  modalStyle?: StyleProp<ViewStyle>;
  closeOnBackdropPress?: boolean;
}
const SCREEN_HEIGHT = Dimensions.get("screen").height;
const BottomDrawer = ({
  allowClose = true,
  visible,
  onClose,
  children,
  modalStyle,
  closeOnBackdropPress,
}: PropsWithChildren<Props>) => {
  const { mediaStyles } = useContext(ResponsiveContext);

  return (
    <Modal
      // animationType="slide"
      transparent
      visible={visible}
      onRequestClose={() => allowClose && onClose?.()}
    >
      <View style={visible && styles.background}>
        {closeOnBackdropPress && (
          <Pressable
            onPress={() => onClose?.()}
            style={[StyleSheet.absoluteFill, { zIndex: 1 }]}
          />
        )}
        <View
          style={[
            styles.modal,
            mediaStyles({
              desktopStyle: styles.modalDesktop,
              tabletStyle: styles.modalDesktop,
            }),
            COMMON_STYLES.ph1,
            COMMON_STYLES["pt3/2"],
            modalStyle,
          ]}
        >
          {allowClose && (
            <View style={styles.cross}>
              <TouchableOpacity onPress={onClose}>
                <CrossIcon
                  height={25}
                  width={25}
                  fill="none"
                  strokeWidth="1.5"
                  stroke={COLORS.neutral90}
                />
              </TouchableOpacity>
            </View>
          )}
          {children}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  background: {
    height: "100%",
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  modal: {
    position: "absolute",
    bottom: 0,
    backgroundColor: COLORS.white,
    borderTopRightRadius: 24,
    borderTopLeftRadius: 24,
    shadowColor: COLORS.black,
    elevation: 5,
    width: "100%",
    flex: 1,
    maxHeight: 0.9 * SCREEN_HEIGHT,
    zIndex: 2,
  },
  modalDesktop: {
    top: "50%",
    left: "50%",
    transform: [{ translateX: "-50%" }, { translateY: "-50%" }],
    bottom: "auto",
    maxWidth: 576,
    borderRadius: 24,
  },
  cross: {
    flexDirection: "row",
    justifyContent: "flex-end",
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: -14.5,
    marginRight: 16,
    backgroundColor: COLORS.white,
    borderRadius: 999,
    elevation: 1,
    padding: 4,
    zIndex: 1,
  },
});

export default BottomDrawer;
